import { Component } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { isObservable, map, of } from 'rxjs';

@Component({
    selector: 'formly-field-primeng-multicheckbox',
    template: `
    <!-- <div class="formly-primeng-multicheckbox">
        <label *ngIf="to.label" class="form-label">{{ to.label }}</label>
        <div class="p-field-checkbox-group">
            <div class="p-field-checkbox" *ngFor="let option of (options$ | async)">
                <p-checkbox [value]="option.value" [label]="option.label" [formControl]="getOptionControl(option.value)"
                    [formlyAttributes]="field"> </p-checkbox>
            </div>
        </div>
        <small *ngIf="description" class="form-description">{{ description }}</small>
    </div> -->
    <div class="formly-primeng-radio">
        <label *ngIf="to.label" class="form-label">{{ to.label }}</label>
        <div class="p-field-radiobutton-group">
            <div class="p-field-radiobutton" *ngFor="let option of (options$ | async); let j = index">
                <p-radioButton [value]="option.value" [formControl]="formControlTyped" [name]="id"
                    [disabled]="to.disabled ?? false" [formlyAttributes]="field" [inputId]="id + '-' + j">
                </p-radioButton>
                <label [for]="id + '-' + j">
                    <i *ngIf="option.icon" [class]="option.icon"></i>
                    {{ option.label }}
                </label>
            </div>
        </div>
        <small *ngIf="description" class="form-description">{{ description }}</small>
    </div>
    `,
})
export class FormlyFieldPrimengMulticheckboxComponent extends FieldType {


    get formControlTyped(): FormControl {
        return this.formControl as FormControl;
    }

    get options$() {
        const opts = this.to.options;
        return isObservable(opts)
            ? opts.pipe(map((options: any[] | null) => options ?? []))
            : of(opts ?? []);
    }

    getOptionControl(optionValue: any): FormControl {
        return this.formControlTyped.get(optionValue) as FormControl;
    }

    get description() {
        return this.to.description;
    }
}